/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

import { logger } from "../../../lib/logger";

class AutoRollLogic {
  static ROLL_OK = 0;
  static ROLL_STOP_ON_LOSS = 1;
  static ROLL_STOP_ON_WIN = 2;
  static ROLL_STOP_ON_NUMBETS = 3;

  bet = 0;
  base_bet = 0;
  maxBet = 0;
  onLossReset = 0;
  onLossPercent = 0;
  onWinReset = 0;
  onWinPercent = 0;
  stopOnLoss = 0;
  stopOnWin = 0;
  autoNumBets = 0;
  numBets = 0;
  toFix = 0;
  data = {};

  setSettings(
    _bet,
    _maxBet,
    _onLossReset,
    _onLossPercent,
    _onWinReset,
    _onWinPercent,
    _stopOnLoss,
    _stopOnWin,
    _autoNumBets,
    _toFix
  ) {
    logger.log(
      "_bet=" +
      _bet +
      "_maxBet=" +
      _maxBet +
      ", _onLossReset=" +
      _onLossReset +
      ", _onLossPercent=" +
      _onLossPercent +
      ", _onWinReset=" +
      _onWinReset +
      ", _onWinPercent=" +
      _onWinPercent +
      ", _stopOnLoss=" +
      _stopOnLoss +
      ", _stopOnWin=" +
      _stopOnWin,
      ", _toFix=" + _toFix
    );
    this.numBets = 0;
    this.bet = +_bet;
    this.base_bet = _bet;
    this.maxBet = _maxBet;
    this.onLossReset = _onLossReset;
    this.onLossPercent = _onLossPercent;
    this.onWinReset = _onWinReset;
    this.onWinPercent = _onWinPercent;
    this.stopOnLoss = _stopOnLoss;
    this.stopOnWin = _stopOnWin;
    this.autoNumBets = _autoNumBets;
    this.toFix = _toFix;
    this.ggr = 0;
    if (this.onWinReset === "1") this.onWinPercent = 0;
    if (this.onLossReset === "1") this.onLossPercent = 0;
  }
  nextStep(_win) {
    // region  STOP ON NUMBER OF BETS
    this.numBets++;
    if (this.autoNumBets > 0) {
      if (this.numBets >= this.autoNumBets) {
        logger.log(
          "stop this.numBets=" + this.numBets,
          ", this.autoNumBets=" + this.autoNumBets
        );
        return AutoRollLogic.ROLL_STOP_ON_NUMBETS;
      }
    }

    // endregion

    this.ggr += +_win;
    logger.log(this.ggr);
    // region  STOP ON LOSS

    if (this.stopOnLoss > 0 && this.ggr < 0) {
      var _ggr = -this.ggr;
      if (_ggr >= this.stopOnLoss) {
        logger.log(
          "stop this.ggr = " +
          this.ggr +
          ", this.stopOnLoss = " +
          this.stopOnLoss
        );
        return AutoRollLogic.ROLL_STOP_ON_LOSS;
      }
    }

    // endregion

    // region  STOP ON WIN

    if (this.stopOnWin > 0 && this.ggr > 0) {
      if (this.ggr >= this.stopOnWin) {
        logger.log(
          "stop this.ggr=" + this.ggr + ", this.stopOnWin=" + this.stopOnWin
        );
        return AutoRollLogic.ROLL_STOP_ON_WIN;
      }
    }

    // endregion

    // region  INCREASE OR RESET BET

    if (_win > 0) {
      if (this.onWinPercent > 0) {
        // increase bet on WIN
        this.bet = (+this.bet + (this.bet * +this.onWinPercent) / 100).toFixed(
          this.toFix
        );
      } else if (this.onWinReset === "1") {
        // reset bet on WIN
        this.bet = +this.base_bet;
      }
    } else if (_win < 0) {
      if (this.onLossPercent > 0) {
        // increase bet on LOSE
        this.bet = (+this.bet + (this.bet * +this.onLossPercent) / 100).toFixed(
          this.toFix
        );
      } else if (this.onLossReset === "1") {
        // reset bet on LOSE
        this.bet = +this.base_bet;
      }
    } else if (_win === 0) {
    }
    // endregion
    return AutoRollLogic.ROLL_OK;
  }
}
export default AutoRollLogic;
